import { TranslatePipe } from '../../filters/translate.pipe';
import { ItemMessageGroupComponent } from '../../components/item-message-group/item-message-group.component';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { InputMessengerComponent } from '../../components/input-messenger/input-messenger.component';
import { ItemMessageComponent } from '../../components/item-message/item-message.component';
import { ItemNotificationComponent } from '../../components/item-notification/item-notification.component';
import { ElementRef } from '@angular/core';
import { Component, OnInit, inject, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import ChatRestServices from '../../services/chat-rest.service';
import Config from '../../utils/config.service';
import Session from '../../utils/session.service';
import ProfilePictureService from '../../services/profile-picture.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import $ from 'jquery';
import moment from 'moment';
import { Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
	standalone: true,
	selector: 'item-messenger',
	templateUrl: './item-messenger.component.html',
	imports: [
		CommonModule, TranslatePipe, ItemMessageGroupComponent, 
		LoaderOverlayComponent, InputMessengerComponent,
		ItemMessageComponent, ItemNotificationComponent, FormsModule
	]
})
export class ItemMessengerComponent implements OnInit, OnDestroy {
	private chatRestServices: ChatRestServices = inject(ChatRestServices);
	private config: Config = inject(Config);
	private session: Session = inject(Session);
	private profilePictureService: ProfilePictureService = inject(ProfilePictureService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	
	@Input() isInfoHidden: any | undefined;
	@Output() isInfoHiddenChange: EventEmitter<any> = new EventEmitter<any>(); // TODO ANGULAR_2: fix calling event emitter
	@Input() isPopup: any | undefined;
	@Input() chat: any;
	
	vm: any = undefined;
	watcher: any = undefined;
	broadcastSubscriptions: Array<Subscription> = [];
	
	constructor(private elementRef: ElementRef) {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.user = this.session.getSession().user;
		
		this.vm.area = this.angularHelperService.element(this.elementRef.nativeElement)[0].querySelector('.c-content--scroll');
		this.vm.pageSize = 20;
		this.vm.getProfilePictureUrl = this.profilePictureService.getProfilePictureUrl;
		this.vm.initialized = true;
		this.vm.pendingGroups = [];
		this.vm.isOtherTyping = {};
		this.vm.lastSeenPostId = 0;
		this.vm.seenChatEventIds = new Set();
		
		this.handleChatChange(this.vm.chat);
		
		var currentMessageCount = undefined;
		this.vm.messageCheckInterval = this.angularHelperService.createInterval(() => {
			if (this.vm.messages && this.vm.messages.length != currentMessageCount) {
				currentMessageCount = this.vm.messages.length;
				this.renderMessages();
			}
		}, 200);

		// this.angularStateHelperService.scopeWM(this, 'this.vm.chat.id', this.handleChatChange);
		var currentChat = undefined;
		this.vm.chatCheckInterval = this.angularHelperService.createInterval(() => {
			if (this.vm.chat && currentChat != this.vm.chat.id) {
				currentChat = this.vm.chat.id;
				this.handleChatChange(this.vm.chat.id);
			}
		}, 200);

		this.broadcastSubscriptions.push(this.angularBroadcastHelperService.onEvent(this,
			this.config.getBroadcastConfig().Chat.NEW_MESSAGE,
			(e, messages, chatId) => { this.handleNewMessage(e, messages, chatId); }));
		this.broadcastSubscriptions.push(this.angularBroadcastHelperService.onEvent(this,
			this.config.getBroadcastConfig().Chat.NEW_EVENT,
			(e, chatEvents, chatId) => { this.handleNewEvents(e, chatEvents, chatId); }));
		this.broadcastSubscriptions.push(this.angularBroadcastHelperService.onEvent(this,
			this.config.getBroadcastConfig().Chat.CHAT_POST_EDITED,
			(e, chatEvents, chatId) => { this.handleUpdatedMessage(e, chatEvents, chatId); }));
		this.broadcastSubscriptions.push(this.angularBroadcastHelperService.onEvent(this,
			this.config.getBroadcastConfig().Chat.CHAT_POST_DELETED,
			(e, chatEvents, chatId) => { this.handleDeletedMessage(e, chatEvents, chatId); }));
		this.broadcastSubscriptions.push(this.angularBroadcastHelperService.onEvent(this,
			this.config.getBroadcastConfig().Chat.MEDIA_UPLOAD_INIT,
			(e, data) => { this.handleMediaUploadInit(e, data); }));
		this.broadcastSubscriptions.push(this.angularBroadcastHelperService.onEvent(this,
			this.config.getBroadcastConfig().Chat.MEDIA_UPLOAD_START,
			(e, media) => { this.handleMediaUploadStart(e, media); }));
		this.broadcastSubscriptions.push(this.angularBroadcastHelperService.onEvent(this,
			this.config.getBroadcastConfig().Chat.MEDIA_UPLOAD_ERROR,
			(e, media) => { this.handleMediaUploadError(e, media); }));
	};
	
	ngOnDestroy() {
		$(this.vm.area).off('scroll.load');
		if (this.vm.scrollTimeout) {
			this.angularHelperService.cancelTimer(this.vm.scrollTimeout);
		}
		if (this.vm.chatCheckInterval) {
			this.angularHelperService.cancelInterval(this.vm.chatCheckInterval);
		}
		if (this.vm.messageCheckInterval) {
			this.angularHelperService.cancelInterval(this.vm.messageCheckInterval);
		}
		if (this.watcher) {
			this.angularHelperService.cancelInterval(this.watcher);
		}
		for (var b = 0; b < this.broadcastSubscriptions.length; b++) {
			this.broadcastSubscriptions[b].unsubscribe();
		}
	}
	
	renderMessages() {
		if (!this.vm.groups || !Array.isArray(this.vm.groups) || !this.vm.messages || !this.vm.messages.length) return;
		
		var oldGroups: any = this.vm.groups.slice();
		var newGroups: any = this.groupMessages(this.vm.messages.slice());
		var isInitial: any = !oldGroups.length;
		
		if (isInitial) {
			this.vm.groups = newGroups;
			return;
		}
		
		var oldFirstMessage: any = this.getFirstMessage(oldGroups);
		var newFirstMessage: any = this.getFirstMessage(newGroups);
		var isAddedBefore: any = oldFirstMessage.id !== newFirstMessage.id;
		if (isAddedBefore) this.renderMessagesBefore(newGroups, oldGroups);
		
		var oldLastMessage: any = this.getLastMessage(oldGroups);
		var newLastMessage: any = this.getLastMessage(newGroups);
		var isAddedAfter: any = oldLastMessage.id !== newLastMessage.id;
		if (isAddedAfter) this.renderMessagesAfter(newGroups, oldGroups);
		
		if (!isAddedBefore && !isAddedAfter) this.renderMessagesBetween(newGroups, oldGroups);
	}
	
	renderMessagesBetween(newGroups, oldGroups) {
		this.vm.groups = newGroups;
	}
	
	renderMessagesAfter(newGroups, oldGroups) {
		var oldLastMessage: any = this.getLastMessage(oldGroups);
		var oldLastGroup: any = this.getLastGroup(oldGroups);
		if (!oldLastGroup || !oldLastMessage.id) return;
		
		var updatedLastGroup: any = this.findGroupByMessageId(newGroups, oldLastMessage.id);
		if (!updatedLastGroup) return;
		
		var messageCountDiff: any = updatedLastGroup.messages.length - oldLastGroup.messages.length;
		if (messageCountDiff > 0) {
			var oldGroupSize: any = oldLastGroup.messages.length;
			for (var i = 0; i < messageCountDiff; i++) {
				var messagePushed: any = updatedLastGroup.messages[oldGroupSize + i];
				if (messagePushed) {
					this.vm.groups[this.vm.groups.length - 1].messages.push(messagePushed);
					this.scrollToBottom();
				}
			}
		}
		
		var groupCountDiff: any = newGroups.length - oldGroups.length;
		if (groupCountDiff > 0) {
			for (var j = 0; j < groupCountDiff; j++) {
				this.vm.groups.push(newGroups[oldGroups.length + j]);
				if (this.vm.isAtBottom) {
					this.scrollToBottom();
				}
			}
		}
	}
	
	renderMessagesBefore(newGroups, oldGroups) {
		var oldFirstMessage: any = this.getFirstMessage(oldGroups);
		var oldFirstGroup: any = this.getFirstMessageGroup(oldGroups);
		if (!oldFirstGroup || !oldFirstMessage.id) return;
		if (this.vm.groups[0].type === 'divider') this.vm.groups.shift();
		
		var updatedFirstGroup: any = this.findGroupByMessageId(newGroups, oldFirstMessage.id);
		if (!updatedFirstGroup) return;
		
		var messageCountDiff: any = updatedFirstGroup.messages.length - oldFirstGroup.messages.length;
		if (messageCountDiff > 0) {
			var i: any = messageCountDiff;
			while (i > -1) {
				this.getScrollPosition();
				this.vm.groups[0].messages.unshift(updatedFirstGroup.messages[i]);
				this.setScrollPosition();
				i--;
			}
		}
		
		var groupCountDiff: any = newGroups.length - oldGroups.length;
		if (groupCountDiff > 0) {
			var j: any = groupCountDiff;
			while (j > -1) {
				this.getScrollPosition();
				this.vm.groups.unshift(newGroups[j]);
				this.setScrollPosition();
				j--;
			}
		}
	}
	
	findGroupByMessageId(groups, id) {
		var index: any = -1;
		groups = groups || [];
		for (var i = 0; i < groups.length; i++) {
			if (groups[i].messages && groups[i].messages.filter((message) => { return message.id === id; }).length) {
				index = i;
				break;
			}
		}
		if (index < 0) return;
		
		return groups[index];
	}
	
	getFirstMessageGroup(groups) {
		if (!groups || !groups.length) return;
		var index: any = -1;
		for (var i = 0; i < groups.length; i++) {
			if (groups[i].type === 'content') {
				index = i;
				break;
			}
		}
		if (index < 0) return;
		
		return groups[index];
	}
	
	getFirstMessage(groups) {
		var firstGroup: any = this.getFirstMessageGroup(groups);
		if (!firstGroup) return {};
		
		return firstGroup.messages && firstGroup.messages[0] || {};
	}
	
	getLastGroup(groups) {
		if (!groups || !groups.length) return;
		return groups.slice(-1)[0];
	}
	
	getLastMessage(groups) {
		var lastGroup: any = this.getLastGroup(groups);
		if (!lastGroup) return {};
		
		return lastGroup.messages.slice(-1)[0] || {};
	}
	
	bindScrollInit() {
		// this.vm.initialized = false; // TODO ANGULAR_2: why is this breaking chat or is it he the scope watch below not being called?
		var currentScrollHeight = undefined;
		this.watcher = this.angularHelperService.createInterval(() => {
			if (this.vm.area.scrollHeight !== currentScrollHeight) {
				currentScrollHeight = this.vm.area.scrollHeight;
				this.handleScrollInit();
			}
		}, 300);
	}
	
	handleScrollInit() {
		if (this.vm.scrollTimeout) this.angularHelperService.cancelTimer(this.vm.scrollTimeout);
		if (!this.vm.initalBottomScrollCompleted) {
			this.scrollToBottom();
		}
		this.vm.scrollTimeout = this.angularHelperService.createTimer(() => {
			this.vm.initialized = true;
			// this.vm.scrollListener(); // TODO ANGULAR_2 scrollListener does not exist, is it a bug?
		}, this.config.getOtherConfig().LOADER_TIMEOUT_DELAY);
	}
	
	handleChatChange(chat) {
		if (this.vm.area) $(this.vm.area).off('scroll.load');
		this.vm.pendingGroups = [];
		if (!chat) {
			if (this.vm.notification) this.vm.notification.hidden = true;
			this.vm.groups = [];
			if (this.vm.isPopup) this.initMessenger();
			return;
		} else {
			this.vm.serviceProviderAiChatActive = this.vm.user?.businessUserType === 'SERVICE_PROVIDER'
				&& !!this.vm.chat.activeAiSessionId;
		}
		this.getMessages(true);
	}
	
	handleNewMessage(e, messages, chatId) {
		// clear typing events for chats with new messages
		if (messages) {
			messages.forEach((message) => {
				this.vm.isOtherTyping[message.chat.id] = false;
			});
		}
		
		if (!messages || !messages.length || !this.vm.chat || parseInt(chatId) !== this.vm.chat.id || this.vm.loading) return;
		if (this.vm.messages && this.vm.messages.length) this.updateMediaOnUpload(messages);
		if (this.vm.messages && this.vm.messages.length) this.updateQuestionnaireOnComplete(messages);
		var newMessages: any = messages.filter((message) => {
			return this.vm.messages && this.vm.messages.filter((item) => {
				return item.id == message.id;
			}).length === 0;
		});
		if (!newMessages.length) return;
		
		this.updateLastSeen(messages.slice(-1).pop());
		this.addMessages(messages);
		if (this.vm.isAtBottom) {
			this.scrollToBottom();
		}
	}
	handleUpdatedMessage(e, messages, chatId) {
		if (!messages || !messages.length || !this.vm.chat || parseInt(chatId) !== this.vm.chat.id) return;

		let updated = false;
		this.vm.messages = this.vm.messages.map(msg => {
			const updatedMsg = messages.find(m => m.id === msg.id);
			if (updatedMsg) {
				updated = true;
				return { ...msg, ...updatedMsg };
			}
			return msg;
		});

		if (updated) {
			this.renderMessages();
		}
	}

	handleDeletedMessage(e, messages, chatId) {
		if (!messages?.length || !this.vm.chat || parseInt(chatId) !== this.vm.chat.id) return;

		let updated = false;

		this.vm.messages = this.vm.messages.map(msg => {
			const updatedMsg = messages.find(m => m.id === msg.id);
			if (updatedMsg) {
				updated = true;
				return {
					...msg,
					deleted: updatedMsg.deleted,
					content: updatedMsg.content || this.angularFilterHelperService.translate('Chats.Other.Deleted')
				};
			}
			return msg;
		});

		if (updated) {
			this.renderMessages();
		}
	}


	handleNewEvents(e, chatEvents, chatId) {
		if (!chatEvents || !chatEvents.length || !this.vm.chat || parseInt(chatId) !== this.vm.chat.id || this.vm.loading) return;
		if (this.vm.messages && this.vm.messages.length) {
			var newEvents: any = chatEvents.filter((chatEvent) => {
				if (!chatEvent || !chatEvent.id) return false;
				if (this.vm.seenChatEventIds.has(chatEvent.id)) return false;
				this.vm.seenChatEventIds.add(chatEvent.id);
				return true;
			});
			if (!newEvents.length) return;
			
			this.processChatEvents(newEvents);
		}
	}
	
	handleMediaUploadInit(e, data) {
		var media: any = data.media;
		var chat: any = data.chat;
		if (!media || !chat || chat !== this.vm.chat.id) return;
		this.vm.pendingGroups = [{ type: 'media', user: this.vm.user.id, messages: [media], id: media.groupId }];
		this.scrollToBottom();
	}
	
	handleMediaUploadStart(e, media) {
		this.vm.pendingGroups = this.vm.pendingGroups.filter((group) => { return group.id !== media.groupId; });
		this.updateLastSeen(media);
		if (!this.vm.messages) this.vm.messages = [];
		if (media.chat.id === this.vm.chat.id || media.chat.localId === this.vm.chat.localId) {
			if (!this.vm.chat.id) {
				this.vm.chat.id = media.chat.id;
			}
			this.vm.messages.push(media);
		}
	}
	
	handleMediaUploadError(e, media) {
		if (media.chat.id !== this.vm.chat.id) return;
		this.vm.pendingGroups = [{ type: 'media', user: this.vm.user.id, messages: [media], id: media.groupId }];
		this.scrollToBottom();
	}
	
	updateQuestionnaireOnComplete(messages) {
		var questionnaireRequestMessages: any = messages.filter((message) => {
			return message.postType === 'TEXT' || message.relatedMetadataType === 'QUESTIONNAIRE_REQUEST';
		});
		if (!questionnaireRequestMessages.length) return;
		var ids: any = questionnaireRequestMessages.map((questionnaire) => { return questionnaire.id; });
		
		this.vm.groups.forEach((group) => {
			if (group.type !== 'questionnaireRequest') return;
			var q: any = group.messages[0];
			var metadata: any = q.metadatas && q.metadatas.find((item) => {
				return item.type === 'QUESTIONNAIRE_REQUEST';
			});
			
			if (metadata) {
				try {
					metadata = JSON.parse(metadata.metadata);
					metadata.type = metadata.type;
				} catch (e) {
					console.error(e);
				}
			}
			if (metadata.status == 'COMPLETED') return;
			if (ids.indexOf(q.id) === -1) return;
			var data: any = questionnaireRequestMessages.filter((item) => { return item.id === q.id })[0];
			if (data) {
				group.messages[0].isCompleted = true;
				group.messages[0].metadatas = data.metadatas;
			}
		});
		
		var lastModifiedMessage: any = messages.reduce((prev, next) => {
			var pd: any = new Date(prev.modified);
			var nd: any = new Date(next.modified);
			return pd > nd ? prev : next;
		});
		
		this.angularBroadcastHelperService.rootBroadcast(
			this.config.getBroadcastConfig().Chat.UPDATE_LAST_POST_SEEN, lastModifiedMessage, this.vm.chat.id);
		this.updateLastSeen(messages.slice(-1).pop());
	}
	
	updateMediaOnUpload(messages) {
		var medias: any = messages.filter((message) => {
			return ((message.postType === 'PICTURE' || message.postType === 'VIDEO') && message.thumbnailUrl)
				|| (message.postType === 'DOCUMENT' && message.fileUrl);
		});
		if (!medias.length) return;
		var ids: any = medias.map((media) => { return media.id; });
		
		this.vm.groups.forEach((group) => {
			if (group.type !== 'media') return;
			var media: any = group.messages[0];
			if (media.thumbnailUrl) return;
			if (ids.indexOf(media.id) === -1) return;
			var data: any = medias.filter((item) => { return item.id === media.id && !media.thumbnailUrl; })[0];
			if (data) {
				group.messages[0].fileUrl = data.fileUrl;
				group.messages[0].thumbnailUrl = data.thumbnailUrl;
				group.messages[0].isUploaded = true;
			}
		});
		
		var lastModifiedMessage: any = messages.reduce((prev, next) => {
			var pd: any = new Date(prev.modified);
			var nd: any = new Date(next.modified);
			return pd > nd ? prev : next;
		});
		
		this.angularBroadcastHelperService.rootBroadcast(
			this.config.getBroadcastConfig().Chat.UPDATE_LAST_POST_SEEN, lastModifiedMessage, this.vm.chat.id);
		this.updateLastSeen(messages.slice(-1).pop());
	}
	
	addMessages(messages, toUnshift?) {
		if (!messages[0] || !messages[0].chat || this.vm.chat.id !== messages[0].chat.id) return;
		var idx;
		if (toUnshift) {
			for (idx in messages) {
				this.vm.messages.unshift(messages[idx]);
			}
		} else {
			const existingIds = new Set(this.vm.messages.map(message => message.id));

			messages.forEach((msg) => {
				if (!existingIds.has(msg.id)) {
					this.vm.messages.push(msg);
					existingIds.add(msg.id);
				}
			});
		}
	}
	
	processChatEvents(chatEvents) {
		if (!chatEvents[0] || !chatEvents[0].chat || this.vm.chat.id !== chatEvents[0].chat.id) return;
		const postIdsToRefresh: Array<any> = [];
		
		chatEvents.forEach((chatEvent, i) => {
			if (chatEvent.eventType === 'TYPING_END') {
				this.vm.isOtherTyping[chatEvent.chat.id] = false;
			} else if (chatEvent.eventType === 'TYPING_START') {
				this.vm.isOtherTyping[chatEvent.chat.id] = true;
				if (this.vm.isAtBottom && chatEvent.chat.id === this.vm.chat.id) {
					this.scrollToBottom();
				}
			} else if (chatEvent.eventType === 'LAST_POST_SEEN_CHANGED') {
				this.angularBroadcastHelperService.rootBroadcast(
					this.config.getBroadcastConfig().Chat.UPDATE_LAST_POST_SEEN, chatEvent, this.vm.chat.id);
				if (chatEvent.lastPostSeenId > this.vm.lastSeenPostId) {
					this.vm.lastSeenPostId = chatEvent.lastPostSeenId;
				}
			} else if (chatEvent.eventType === 'CHATBOT_DISABLED') {
				this.angularBroadcastHelperService.rootBroadcast(
					this.config.getBroadcastConfig().Chat.UPDATE_CHAT_STATUS, chatEvent, this.vm.chat.id);
				this.vm.serviceProviderAiChatActive = false;
			} else if (chatEvent.eventType === 'CHATBOT_ACTIVATED') {
				this.angularBroadcastHelperService.rootBroadcast(
					this.config.getBroadcastConfig().Chat.UPDATE_CHAT_STATUS, chatEvent, this.vm.chat.id);
				this.vm.serviceProviderAiChatActive = this.vm.user?.businessUserType === 'SERVICE_PROVIDER';
			} else if (chatEvent.eventType === 'INTERVENTION_NEEDED') {
				this.angularBroadcastHelperService.rootBroadcast(
					this.config.getBroadcastConfig().Chat.UPDATE_CHAT_STATUS, chatEvent, this.vm.chat.id);
				this.vm.serviceProviderAiChatActive = false;
			} else if (chatEvent.eventType === 'CRITICAL_INTERVENTION_NEEDED') {
				this.angularBroadcastHelperService.rootBroadcast(
					this.config.getBroadcastConfig().Chat.UPDATE_CHAT_STATUS, chatEvent, this.vm.chat.id);
				this.vm.serviceProviderAiChatActive = false;
			} else if (chatEvent.eventType === 'CHAT_ENABLED' || chatEvent.eventType === 'CHAT_DISABLED') {
				this.angularBroadcastHelperService.rootBroadcast(
					this.config.getBroadcastConfig().Chat.UPDATE_CHAT_STATUS, chatEvent, this.vm.chat.id);
				if (chatEvent.eventType === 'CHAT_ENABLED') {
					this.vm.chat.disabled = false;
				} else {
					this.vm.chat.disabled = true;
				}
			} else if (chatEvent.eventType === 'CHATBOT_SUMMARY') {
				this.angularBroadcastHelperService.rootBroadcast(
					this.config.getBroadcastConfig().Chat.UPDATE_CHAT_STATUS, chatEvent, this.vm.chat.id);
			} else if (chatEvent.eventType === 'CHAT_POST_EDITED') {
				if (chatEvent.chatPostId) {
					postIdsToRefresh.push(chatEvent.chatPostId);
				}
            } else if (chatEvent.eventType === 'CHAT_POST_DELETED') {
				if (chatEvent.chatPostId) {
					postIdsToRefresh.push(chatEvent.chatPostId);
				}
            }
		});
		if (postIdsToRefresh.length) {
			this.refreshMessagesByIds(postIdsToRefresh);
		}
	}

	refreshMessagesByIds(postIds) {
		var uniquePostIds: Array<any> = Array.from(new Set((postIds || []).filter((id) => !!id)));
		if (!uniquePostIds.length) return;
		uniquePostIds.forEach((postId) => {
			this.chatRestServices.getChatPostById({ id: postId },
				(res) => {
					if (res) {
						this.updateMessageInMemory(res);
					}
				},
				(err) => {
					console.error('components/item-messenger refreshMessagesByIds error:', err);
				});
		});
	}

	updateMessageInMemory(updatedMessage) {
		if (!updatedMessage || !updatedMessage.id || !this.vm.messages || !this.vm.messages.length) return;
		var updated: any = false;
		this.vm.messages = this.vm.messages.map((message) => {
			if (message.id === updatedMessage.id) {
				updated = true;
				return {
					...message,
					...updatedMessage
				};
			}
			return message;
		});
		if (updated) {
			if (updatedMessage.chat?.id && !this.vm.chat.id) {
				this.vm.chat.id = updatedMessage.chat.id;
			}
			this.renderMessages();
		}
	}
	
	updateLastSeen(message) {
		if (!message || (this.vm.chat.lastSeenPostId && message.id <= this.vm.chat.lastSeenPostId)) return;
		this.vm.chat.lastPostSeen = message.id;
		this.vm.chat.lastSeenPostId = message.id;
		this.chatRestServices.updateLastPostSeen(
			{
				user: { id: this.vm.user.id },
				chat: { id: this.vm.chat.id },
				chatPost: { id: message.id }
			},
			(res) => {
				this.angularBroadcastHelperService.rootBroadcast(
					this.config.getBroadcastConfig().Chat.UPDATE_LAST_POST_SEEN, message, this.vm.chat.id);
			},
			(err) => {
				console.error('components/card-chat updateLastSeen error:', err);
			}
		);
	}
	
	getMessages(isInitial?) {
		if (isInitial) {
			this.vm.loading = true;
			this.vm.groups = [];
			this.vm.messages = [];
			this.vm.pendingGroups = [];
			this.vm.initalBottomScrollCompleted = false;
		} else {
			this.vm.loadingAdditional = true;
			this.vm.initalBottomScrollCompleted = true;
		}
		this.chatRestServices.getConversationMessages(
			{
				chatId: this.vm.chat.id,
				start: this.vm.messages.length,
				end: this.vm.pageSize
			},
			(res) => {
				if (res && res.length) {
					this.vm.lastSeenPostId = res[0].lastPostSeenByOther;
				}
				if (this.vm.groups.length && !isInitial) {
					this.vm.area.scrollTop = this.vm.area.scrollTop || 1; // To avoid anchoring on the top
					this.addMessages(res, true);
				} else {
					res.reverse();
					if (this.vm.chat && res.length 
						&& (res[0].chat.id === this.vm.chat.id || res[0].chat.localId === this.vm.chat.localId)) {
						if (!this.vm.chat.id) {
							this.vm.chat.id = res[0].chat.id;
						}
						this.vm.messages = res;
					}
					this.vm.loading = false;
					this.initMessenger();
				}
				if (res && res.length) this.vm.loadingAdditional = false;
			}
		);
	}
	
	groupMessages(messages) {
		var data: Array<any> = [];
		var group: Array<any> = [];
		this.angularHelperService.forEach(messages, (message, i) => {
			var isFirstRow: any = !i;
			var isNewDay: any = !isFirstRow && !moment(message.created).isSame(messages[i - 1].created, 'day');
			var isNewUser: any = !isFirstRow && message.user.id !== messages[i - 1].user.id;
			var isLastRow: any = i === messages.length - 1;
			var isBusinessCard: any = message.metadatas && message.metadatas.find((item) => {
				return item.type === 'BUSINESS_CARD';
			});
			var isQuestionnaireRequest: any = message.metadatas && message.metadatas.find((item) => {
				return item.type === 'QUESTIONNAIRE_REQUEST';
			});
			var isBookingOffer: any = message.metadatas && message.metadatas.find((item) => {
				return item.type === 'BOOKING_OFFER';
			});
			var isMedia: any = message.postType === 'PICTURE' || message.postType === 'VIDEO'
				|| message.postType === 'DOCUMENT' || isBusinessCard || isQuestionnaireRequest || isBookingOffer;
			
			if (isFirstRow || isNewDay) {
				var d: any = moment(message.created).calendar().split(' ')[0];
				var language: any = (this.vm.user.deviceLanguage || this.config.getSettings().DEFAULT_LANG).slice(0, 2);
				var label: any = (d === 'Today' || d === 'Tomorrow')
					? this.angularFilterHelperService.translate('Services.Time.' + d).toLowerCase()
					: moment(message.created).locale(language).format('ddd, D. MMM');
				if (group.length) {
					data.push({ type: 'content', user: group[0].user.id, messages: group });
					group = [];
				}
				data.push({ type: 'divider', label: label });
			}
			
			if ((isNewDay || isNewUser) && !isMedia) {
				if (group.length) {
					data.push({ type: 'content', user: group[0].user.id, messages: group });
					group = [];
				}
				group.push(message);
			}
			
			if (!isNewDay && !isNewUser && !isMedia) {
				if (group.length) {
					data.push({ type: 'content', user: group[0].user.id, messages: group });
					group = [];
				}
				group.push(message);
			}
			
			if (isLastRow && group.length && !isMedia) {
				if (group.length) {
					data.push({ type: 'content', user: group[0].user.id, messages: group });
					group = [];
				}
				group.push(message);
			}
			
			if (isMedia) {
				if (group.length) {
					data.push({ type: 'content', user: group[0].user.id, messages: group });
					group = [];
				}
				if (isBusinessCard) {
					data.push({ type: 'businessCard', user: message.user.id, messages: [message] });
				} else if (isQuestionnaireRequest) {
					data.push({ type: 'questionnaireRequest', user: message.user.id, messages: [message] });
				} else if (isBookingOffer) {
					data.push({ type: 'bookingOffer', user: message.user.id, messages: [message] });
				} else {
					data.push({ type: 'media', user: message.user.id, messages: [message] });
				}
			}
		});
		return data;
	}
	
	scrollToBottom() {
		// $scope.$$postDigest(() => {
		setTimeout(() => {
			this.vm.area.scrollTop = this.vm.area.scrollHeight * 100;
			this.angularHelperService.createTimer(() => { this.vm.area.scrollTop = this.vm.area.scrollHeight * 100; });
			this.angularHelperService.createTimer(() => { this.vm.area.scrollTop = this.vm.area.scrollHeight * 100; }, 50);
		}, 100);
	}
	
	getScrollPosition() {
		this.vm.scrollPosition = this.vm.area.scrollHeight - this.vm.area.scrollTop;
		return this.vm.scrollPosition;
	}
	
	setScrollPosition() {
		// $scope.$$postDigest(() => {
		setTimeout(() => {
			this.vm.area.scrollTop = this.vm.area.scrollHeight - this.vm.scrollPosition;
		}, 100);
	}
	
	initMessenger() {
		var lastMessage: any = this.vm.messages && this.vm.messages.slice(-1)[0];
		if (lastMessage) this.updateLastSeen(lastMessage);
		// if (!this.vm.notification) this.initNotification();
		this.bindScrollInit();
		this.initScrollHandler();
		this.angularHelperService.createTimer(
			() => {
				this.angularBroadcastHelperService.rootBroadcast(this.config.getBroadcastConfig().Chat.FOCUS_INPUT);
			}
		);
		this.renderMessages();
	}
	
	initNotification() {
		this.vm.notification = {
			icon: 'phone',
			text: this.angularFilterHelperService.translate('Chats.Other.Start_Info'),
			btnText: this.angularFilterHelperService.translate('Common.Got_It'),
			action: () => {
				this.vm.notification.hidden = true;
				this.vm.isInfoHidden = true;
				this.isInfoHiddenChange.emit(this.vm.isInfoHidden);
				this.scrollToBottom();
			}
		};
	}
	
	initScrollHandler() {
		$(this.vm.area).on('scroll.load', () => {
			const area = this.vm.area;
			this.vm.isAtBottom = area.scrollTop + area.clientHeight >= area.scrollHeight;
			
			if (area.scrollTop < 300 && !this.vm.loadingAdditional) {
				this.getMessages();
			}
		});
	}
	
	disableChatBot() {
		this.chatRestServices.disableChatBot({id: this.vm.chat.id},
			(res) => {
				this.vm.chat.activeAiSessionId = res.activeAiSessionId;
				this.vm.serviceProviderAiChatActive = this.vm.user?.businessUserType === 'SERVICE_PROVIDER'
					&& !!res.activeAiSessionId;
			},
			(err) => {
				console.log(err);
			});
	}
	
}
